import {PageResponse} from '../pageResponse';

export class Customer {
  id?: number;
  name?: string;
  status?: string;
  creationDate?: string;
  modifyDate?: string;
}

export class CustomerResponse extends PageResponse {
  content: Customer[];
}


